module.exports = __webpack_public_path__ + "static/media/pins_warning.a787e027.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Buildings/Manage/Map/Marker/img/pins_warning.png
// module id = 1123
// module chunks = 0